<template>
	<div class="form-status" :class="classAndLabel[0]">
		{{ classAndLabel[1] }}
	</div>
</template>

<script>
export default {
	props: ["value"],
	computed: {
		classAndLabel() {
			const status = ["", ""];
			switch (this.value) {
				case "OnOrder":
				case 1:
					status[1] = "On Order";
					status[0] = "form-status-gray";
					break;
				case "Received":
				case 2:
					status[1] = "Received";
					status[0] = "form-status-green";
					break;
				case "PartiallyReceived":
					status[1] = "Partially Received";
					status[0] = "form-status-orange";
					break;
				case "PartiallyShipped":
					status[1] = "Partially Shipped";
					status[0] = "form-status-orange";
					break;
				case "Cancelled":
				case 3:
					status[1] = "Cancelled";
					status[0] = "form-status-red";
					break;
				case "Shipped":
					status[1] = "Shipped";
					status[0] = "form-status-green";
					break;
				default:
					status[1] = "Error";
					status[0] = "form-status-red";
			}
			return status;
		},
	},
};
</script>
<style scoped lang="scss">
.form-status {
	text-transform: uppercase; // statuses read as labels everywhere (#300)
	display: inline-block;
	border: 1px solid;
	border-radius: 3px;
	font-size: 1.4rem;
	padding: 0.6rem 1rem;
	margin-left: 1rem;
	min-width: 10rem;
	text-align: center;

	&-orange {
		border-color: $color-orange;
		color: $color-orange;
	}

	&-green {
		border-color: $color-green;
		color: $color-green;
	}
	&-gray {
		border-color: $color-gray-dark;
		color: $color-gray-dark;
	}
	&-red {
		border-color: red;
		color: red;
	}
}
</style>
